<template>
  <div id="app">
    <AppLayout>
      <router-view/>
    </AppLayout>
  </div>
</template>

<script>
import AppLayout from '@/layout';
export default {
  name: 'App',
  components: {
    AppLayout,
  },
  data() {
    return {
    };
  },
  created() {
  }
};
</script>

<style lang="less">
.el-image-viewer__canvas {
  img {
    height: 100%;
  }
}
</style>
